import { addFormatToken } from '../format-functions';
import { weekOfYear } from './week-calendar-utils';
addFormatToken('w', ['ww', 2], 'wo', function (date, format, locale) {
    return getWeek(date, locale).toString(10);
});
addFormatToken('W', ['WW', 2], 'Wo', function (date) {
    return getISOWeek(date).toString(10);
});
export function getWeek(date, locale) {
    return locale.week(date);
}
export function getISOWeek(date) {
    return weekOfYear(date, 1, 4).week;
}
//# sourceMappingURL=week.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ngx-bootstrap/bs-moment/units/week.js
// module id = ../../../../ngx-bootstrap/bs-moment/units/week.js
// module chunks = 3